import isApiError from "@insite/client-framework/Common/isApiError";
import { sendToShell } from "@insite/client-framework/Components/ShellHole";
import { get, patch, ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    GetSessionApiParameter,
    Session,
    UpdateSessionWithResultApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { SessionModel } from "@insite/client-framework/Types/ApiModels";

export async function getSession(parameter: GetSessionApiParameter) {
    const session = await get<SessionModel>("/api/v1/sessions/current", parameter);
    cleanSession(session);
    informShell(session);
    return session;
}

export async function updateSessionWithResult(
    parameter: UpdateSessionWithResultApiParameter,
): Promise<ServiceResult<SessionModel>> {
    try {
        let queryString = "";
        for (const key in parameter.additionalQueryStringParameters) {
            queryString += `${key}=${encodeURIComponent(parameter.additionalQueryStringParameters[key])}&`;
        }

        const endpoint = "/api/v1/sessions/current";
        if (queryString !== "") {
            queryString = (endpoint.indexOf("?") < 0 ? "?" : "&") + queryString.substring(0, queryString.length - 1);
        }

        const session = await patch<SessionModel>(endpoint + queryString, parameter.session);
        cleanSession(session);
        return {
            successful: true,
            result: session,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.message,
            };
        }
        throw error;
    }
}

function cleanSession(session: SessionModel) {
    if (session.billTo) {
        (session as Session).billToId = session.billTo.id;
    }

    if (session.shipTo) {
        (session as Session).shipToId = session.shipTo.id;
        session.shipTo = null;
    }
}

function informShell(session: SessionModel) {
    sendToShell({
        type: "FrontEndSessionLoaded",
        personas: session.personas,
    });
}
